// src/components/dashboard/StorageOverviewCard.jsx
import React, { useEffect, useState } from 'react';
import { fetchStorageData, formatFileSize } from '../../services/api.service';
import { getUsedPercentage } from '../../utils/storage.utils';

const StorageOverviewCard = ({ maxSize }) => {
  const [totalUsed, setTotalUsed] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const token = sessionStorage.getItem('authToken');
        const data = await fetchStorageData(token);

        const orderedBuckets = ['files', 'passwords', 'bankcards', 'blockchain'];
        const filtered = data.bucketSizes?.filter(bucket =>
          orderedBuckets.includes(bucket.bucket)
        ) || [];

        const total = filtered.reduce((sum, bucket) => sum + bucket.size, 0);
        setTotalUsed(total);
      } catch (error) {
        console.error('Error loading storage overview:', error);
        setTotalUsed(0);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const usedPercent = getUsedPercentage(totalUsed, maxSize);

  return (
    <div className="col-12">
      <div className="card border-left-success shadow h-100 py-2">
        <div className="card-body">
          <div className="row no-gutters align-items-center">
            <div className="col mr-2">
              <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                Total Storage Usage
              </div>
              {loading ? (
                <div className="spinner-border text-success mt-2" role="status" />
              ) : (
                <>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">
                    {formatFileSize(totalUsed)} used of {formatFileSize(maxSize)}
                  </div>
                  <div className="progress mt-2" style={{ height: '8px' }}>
                    <div
                      className="progress-bar bg-success"
                      role="progressbar"
                      style={{ width: `${usedPercent}%` }}
                    ></div>
                  </div>
                  <div className="mt-1 small text-black">{usedPercent}% used</div>
                </>
              )}
            </div>
            <div className="col-auto">
              <i className="fas fa-hdd fa-2x text-gray-300"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StorageOverviewCard;
